import cx from 'classnames'
import * as React from 'react'

import Text from '../text'

import appStoreImage from './download-app-store.svg'
import googlePlayImage from './download-google-play.svg'
import styles from './footer.module.scss'

export type Props = {
  links: Array<React.ReactNode>
  onDownloadLinkClick?: (store: 'app-store' | 'play-store') => void
} & JSX.IntrinsicElements['footer']

const Footer = ({
  links,
  onDownloadLinkClick,
  className,
  ...footerProps
}: Props) => {
  return (
    <footer {...footerProps} className={cx(styles.footer, className)}>
      <div className={styles.inner}>
        <div className={styles.main}>
          <Text color="inverted" marginBottom="medium" className={styles.links}>
            {links.map((link) => link)}
          </Text>
          <Text color="inverted">
            Monzo Bank Limited is a company registered in England and Wales (No.
            09446231). Monzo Bank Ltd is authorised by the Prudential Regulation
            Authority (PRA) and regulated by the Financial Conduct Authority and
            the Prudential Regulation Authority (PRA). Our Financial Services
            Register number is 730427.
          </Text>
        </div>
        <div className={styles.downloadButtons}>
          <a
            href="https://monzo.com/download"
            className={styles.downloadLink}
            onClick={() =>
              onDownloadLinkClick && onDownloadLinkClick('app-store')
            }
          >
            <span className={styles.hiddenLabel}>
              Download Monzo from the App Store
            </span>
            <img src={appStoreImage as string} alt="" />
          </a>
          <a
            href="https://monzo.com/download"
            className={styles.downloadLink}
            onClick={() =>
              onDownloadLinkClick && onDownloadLinkClick('play-store')
            }
          >
            <span className={styles.hiddenLabel}>
              Download Monzo from the Google Play Store
            </span>
            <img src={googlePlayImage as string} alt="" />
          </a>
        </div>
      </div>
    </footer>
  )
}

export default Footer
